import React from "react"

function BackArrowSvg(props) {
	return (
		<svg width={12} height={12} xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M5.15626 11.475L0.206262 6.52499C0.131262 6.44999 0.0780116 6.36873 0.0465116 6.28123C0.0150116 6.19373 -0.000488281 6.09998 1.17189e-05 5.99998C1.17189e-05 5.89998 0.0157619 5.80623 0.0472619 5.71873C0.0787619 5.63123 0.131762 5.54998 0.206262 5.47499L5.15626 0.524984C5.29376 0.387484 5.46576 0.315734 5.67226 0.309734C5.87876 0.303734 6.05676 0.375484 6.20626 0.524984C6.35626 0.662484 6.43451 0.834484 6.44101 1.04098C6.44751 1.24748 6.37551 1.42548 6.22501 1.57498L2.55001 5.24998H10.9313C11.1438 5.24998 11.322 5.32198 11.466 5.46598C11.61 5.60998 11.6818 5.78798 11.6813 5.99998C11.6813 6.21248 11.6095 6.39074 11.466 6.53474C11.3225 6.67874 11.1443 6.75049 10.9313 6.74999H2.55001L6.22501 10.425C6.36251 10.5625 6.43451 10.7375 6.44101 10.95C6.44751 11.1625 6.37551 11.3375 6.22501 11.475C6.08751 11.625 5.91251 11.7 5.70001 11.7C5.48751 11.7 5.30626 11.625 5.15626 11.475Z"
				fill="#fff"
			/>
		</svg>
	)
}
export default BackArrowSvg
